<template>
  <div>
    <div class="card">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-5">{{ $t('catalogue.popUpDispoFace.gestion')}}</h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <error-msg-component :messages="messages"
                             :error="error"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <div class="columns mgt-10px">
          <b-field :label="$t('catalogue.popUpDispoFace.disponibilite')"
                   class="column is-12 obligatoire">
            <b-select v-model="modificationDispoFace.stock" expanded>
              <option v-for="dispo in dispoStatus"
                      :key="dispo.code"
                      :value="dispo.code">
                {{ $t(dispo.libelle)}}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="columns">
          <b-field :label="$t('catalogue.popUpDispoFace.dateDebut')"
                   class="obligatoire column is-6">
            <b-datepicker show-week-number icon="calendar-today"
              v-model="dateDebutDisplay"
              nearby-selectable-month-days
              :editable="true"></b-datepicker>
          </b-field>
          <b-field :label="$t('catalogue.popUpDispoFace.dateFin')"
                   class="column is-6">
            <b-datepicker show-week-number
              nearby-selectable-month-days
              icon="calendar-today" v-model="dateFinDisplay"
              :editable="true">
            </b-datepicker>
          </b-field>
        </div>
        <div class="columns">
          <b-field :label="$t('catalogue.popUpDispoFace.commentaire')"
                   class="column is-12 pdt-0">
            <b-input v-model="modificationDispoFace.commentaire"
                     type="textarea" maxlength="255">
            </b-input>
          </b-field>
        </div>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close">
              {{ $t('catalogue.popUpDispoFace.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="enregistrerDispo">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import validationProduit from '@/services/catalogue/validation/validationProduit';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import { addDisponibiliteReseauLC } from '@/api/dispo/index';
import formatDate from '@/services/general/formatIsoDate';
import { LISTE_DISPONIBILITE } from '@/configuration/catalogue/disponibiliteConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  props: {
    infoJourSelect: Object,
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      messages: [],
      error: false,
      dispoStatus: LISTE_DISPONIBILITE,
      dateDebutDisplay: new Date(this.infoJourSelect.date),
      dateFinDisplay: new Date(this.infoJourSelect.date),
      modificationDispoFace: {
        commentaire: this.infoJourSelect.commentaire,
        dateDebut: this.infoJourSelect.dateDebut,
        dateFin: this.infoJourSelect.dateFin,
        produitId: this.infoJourSelect.produitId,
        stock: this.infoJourSelect.stock,
      },
    };
  },
  mounted() {
    if (this.modificationDispoFace.stock === 0) this.modificationDispoFace.stock = 1;
    else this.modificationDispoFace.stock = 0;
  },
  methods: {
    async enregistrerDispo() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.modificationDispoFace.dateDebut = formatDate(this.dateDebutDisplay);
        this.modificationDispoFace.dateFin = formatDate(this.dateFinDisplay);
        await addDisponibiliteReseauLC(this.modificationDispoFace);
        messageSucces(this.$t('catalogue.popUpDispoFace.dispoAdd'));
        loadingComponent.close();
        this.$parent.close();
        this.$emit('reloadDispoFace');
      } catch (e) {
        if (e.response.data.error) {
          this.messages = validationProduit(e.response);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
};
</script>
